(() => {
  const money = (cents) => {
    try {
      if (window.Shopify && Shopify.currency && Shopify.currency.active) {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: Shopify.currency.active }).format((Number(cents) || 0) / 100);
      }
    } catch (e) {}
    return '$' + ((Number(cents) || 0) / 100).toFixed(2);
  };

  function initPdp(root) {
    if (!root || root.dataset.acPdpReady === 'true') return;
    root.dataset.acPdpReady = 'true';

    const variantsScript = root.querySelector('[data-ac-pdp-variants]');
    let variants = [];
    try { variants = JSON.parse(variantsScript?.textContent || '[]'); } catch (e) { console.warn('AC PDP: variant JSON could not be parsed', e); }

    const productForm = root.querySelector('product-form form');
    const variantIdInput = productForm?.querySelector('input[name="id"]');
    const priceEl = root.querySelector('[data-ac-pdp-price]');
    const compareEl = root.querySelector('[data-ac-pdp-compare]');
    const summaryEl = root.querySelector('[data-ac-pdp-variant-summary]');
    const submit = root.querySelector('[data-ac-pdp-submit]');
    const submitText = root.querySelector('[data-ac-pdp-submit-text]');
    const sticky = document.querySelector('[data-ac-pdp-sticky]');
    const stickyPrice = sticky?.querySelector('[data-ac-pdp-sticky-price]');
    const stickyOption = sticky?.querySelector('[data-ac-pdp-sticky-option]');
    const stickySubmit = sticky?.querySelector('[data-ac-pdp-sticky-submit]');

    const syncKlaviyoBis = (available) => {
      root.dataset.acVariantAvailable = available ? 'true' : 'false';
      root.querySelectorAll('.klaviyo-bis-trigger').forEach(trigger => {
        trigger.hidden = available;
        trigger.style.setProperty('display', available ? 'none' : 'flex', 'important');
      });
    };

    const selectedOptions = () => Array.from(root.querySelectorAll('[data-ac-pdp-option]')).map(group => group.querySelector('[data-ac-pdp-option-input]:checked')?.value || '');

    const currentVariant = () => {
      const options = selectedOptions();
      const byId = variants.find(v => String(v.id) === String(variantIdInput?.value));
      if (!options.length) return byId || variants[0];
      return variants.find(v => Array.isArray(v.options) && v.options.every((value, index) => value === options[index])) || byId || variants[0];
    };

    const isAvailable = (variant) => variant && variant.available !== false;

    const updateOptionAvailability = () => {
      if (!variants.length) return;
      const groups = Array.from(root.querySelectorAll('[data-ac-pdp-option]'));
      const selected = selectedOptions();
      groups.forEach((group, optionIndex) => {
        group.querySelectorAll('[data-ac-pdp-option-input]').forEach(input => {
          const candidateValue = input.value;
          const hasAvailableVariant = variants.some(variant => {
            if (!isAvailable(variant) || !Array.isArray(variant.options)) return false;
            return variant.options.every((variantValue, index) => {
              if (index === optionIndex) return variantValue === candidateValue;
              return !selected[index] || variantValue === selected[index];
            });
          });
          const label = input.closest('.ac-pdp__option-pill');
          if (!label) return;
          label.classList.toggle('is-unavailable', !hasAvailableVariant);
          label.dataset.stockLabel = hasAvailableVariant ? '' : 'Out of stock';
          label.setAttribute('aria-label', hasAvailableVariant ? candidateValue : `${candidateValue} — Out of stock`);
          input.setAttribute('aria-disabled', hasAvailableVariant ? 'false' : 'true');
          input.disabled = !hasAvailableVariant && !input.checked;
        });
      });
    };

    const updateVariant = () => {
      const variant = currentVariant();
      root.querySelectorAll('.ac-pdp__option-pill').forEach(label => label.classList.toggle('is-selected', !!label.querySelector('input:checked')));
      updateOptionAvailability();
      if (!variant) return;

      const available = isAvailable(variant);
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        compareEl.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';
        compareEl.hidden = !(variant.compare_at_price > variant.price);
      }
      if (summaryEl) summaryEl.textContent = variant.title === 'Default Title' ? '' : variant.title;
      if (submit) submit.disabled = !available;
      if (submitText) submitText.textContent = available ? `Add to cart · ${money(variant.price)}` : 'Sold out';
      if (stickyPrice) stickyPrice.textContent = money(variant.price);
      if (stickyOption) stickyOption.textContent = variant.title === 'Default Title' ? '' : ` · ${variant.title}`;
      if (stickySubmit) {
        stickySubmit.disabled = !available;
        stickySubmit.textContent = available ? 'Add to cart' : 'Sold out';
      }
      syncKlaviyoBis(available);

      if (variant.featured_image && variant.featured_image.src) {
        const main = root.querySelector('[data-ac-pdp-main-image]');
        if (main) {
          // The initial image has a responsive srcset. Updating only `src` lets the
          // browser keep rendering the old srcset candidate, so clear it first.
          main.removeAttribute('srcset');
          main.src = variant.featured_image.src;
          if (variant.featured_image.alt) main.alt = variant.featured_image.alt;
        }
        root.querySelectorAll('[data-ac-pdp-thumb]').forEach(thumb => {
          thumb.classList.toggle('is-active', String(thumb.dataset.mediaId || '') === String(variant.featured_image.media_id || ''));
        });
      }
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
      } catch (e) {}
    };

    root.querySelectorAll('[data-ac-pdp-option-input]').forEach(input => input.addEventListener('change', updateVariant));

    if (productForm && window.MutationObserver) {
      const bisObserver = new MutationObserver(() => {
        const variant = currentVariant();
        syncKlaviyoBis(isAvailable(variant));
      });
      bisObserver.observe(productForm, { childList: true, subtree: true });
    }

    const qty = root.querySelector('[data-ac-qty-input]');
    root.querySelector('[data-ac-qty-minus]')?.addEventListener('click', () => { if (qty) qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
    root.querySelector('[data-ac-qty-plus]')?.addEventListener('click', () => { if (qty) qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + 1); });

    root.querySelectorAll('[data-ac-pdp-thumb]').forEach(button => button.addEventListener('click', () => {
      const main = root.querySelector('[data-ac-pdp-main-image]');
      if (!main || !button.dataset.imageSrc) return;

      // Do not leave the original responsive srcset in place: browsers may keep
      // choosing its old candidate even after `src` changes.
      main.removeAttribute('srcset');
      main.src = button.dataset.imageSrc;
      main.alt = button.dataset.imageAlt || main.alt;

      root.querySelectorAll('[data-ac-pdp-thumb]').forEach(x => {
        x.classList.remove('is-active');
        x.setAttribute('aria-current', 'false');
      });
      button.classList.add('is-active');
      button.setAttribute('aria-current', 'true');
    }));

    const description = root.querySelector('[data-ac-pdp-description]');
    if (description) {
      const labels = ['days to maturity','sow method','sow depth','sowing depth','spacing','sun:','height:','germination'];
      description.querySelectorAll('ul').forEach(list => {
        const text = (list.textContent || '').toLowerCase();
        const hits = labels.filter(label => text.includes(label)).length;
        if (hits >= 2) list.remove();
      });
      description.querySelectorAll('div,p').forEach(node => {
        const text = (node.textContent || '').trim().toLowerCase();
        if (/^catalog page\s*:/.test(text)) node.remove();
      });
    }

    if (sticky && productForm) {
      sticky.hidden = false;
      sticky.setAttribute('aria-hidden', 'false');

      stickySubmit?.addEventListener('click', () => {
        if (!stickySubmit.disabled) productForm.requestSubmit();
      });
    }

    updateVariant();
  }

  function initPdpBreadcrumb(root) {
    const nav = root?.querySelector('[data-ac-pdp-breadcrumb]');
    if (!nav || nav.dataset.acBreadcrumbContext === 'true') return;

    let referrer;
    try {
      if (!document.referrer) return;
      referrer = new URL(document.referrer);
    } catch (e) {
      return;
    }

    if (referrer.origin !== window.location.origin) return;
    const match = referrer.pathname.match(/^\/collections\/([^/]+)/i);
    if (!match) return;

    let handle = '';
    try { handle = decodeURIComponent(match[1]).toLowerCase(); } catch (e) { handle = String(match[1] || '').toLowerCase(); }
    const ignored = new Set(['all', 'seeds', 'all-summer-collection', 'summer-collection']);
    if (!handle || ignored.has(handle) || handle.includes('all-summer') || handle.includes('summer-collection')) return;

    const specialTitles = {
      'quick-crops': 'Quick Crops',
      'lettuce-mesclun': 'Lettuce & Mesclun',
      'carrots-roots': 'Carrots & Roots'
    };
    let title = specialTitles[handle];
    if (!title) {
      const zone = handle.match(/^zone-(\d+[a-z]?)$/i);
      if (zone) title = `Zone ${zone[1]}`;
    }
    if (!title) {
      title = handle
        .split('-')
        .filter(Boolean)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    }

    let link = nav.querySelector('[data-ac-pdp-breadcrumb-collection]');
    let separator = nav.querySelector('[data-ac-pdp-breadcrumb-separator]');
    const productTitle = nav.querySelector('strong');
    if (!productTitle) return;

    if (!link) {
      link = document.createElement('a');
      link.setAttribute('data-ac-pdp-breadcrumb-collection', '');
      separator = document.createElement('span');
      separator.setAttribute('data-ac-pdp-breadcrumb-separator', '');
      separator.textContent = '/';
      nav.insertBefore(link, productTitle);
      nav.insertBefore(separator, productTitle);
    }

    link.href = `/collections/${encodeURIComponent(handle)}`;
    link.textContent = title;
  }

  function bindCartFlyout() {
    if (window.__acPdpCartBound) return;
    window.__acPdpCartBound = true;
    window.CART_REDIRECTION_ENABLED = window.CART_REDIRECTION_ENABLED ?? false;
    window.SHOP_MONEY_FORMAT = window.SHOP_MONEY_FORMAT || '${{amount}}';

    document.addEventListener('product-form:cart:request', (event) => {
      if (!event.target.closest('.ac-pdp') || window.CART_REDIRECTION_ENABLED || !window.AddToCartFlyout) return;
      event.preventDefault();
      try {
        const formDataArray = [];
        for (const [name, value] of event.detail.form.entries()) formDataArray.push({ name, value });
        const button = event.target.closest('.ac-pdp')?.querySelector('[data-ac-pdp-submit]');
        new window.AddToCartFlyout(formDataArray, { atcButton: button, settings: { moneyFormat: window.SHOP_MONEY_FORMAT } });
        const complete = (e) => { cleanup(); event.detail.resolve(e.detail.responseData); };
        const error = (e) => { cleanup(); event.detail.reject(e.detail.error); };
        const cleanup = () => {
          document.removeEventListener('addToCartFlyout:complete', complete);
          document.removeEventListener('addToCartFlyout:error', error);
        };
        document.addEventListener('addToCartFlyout:complete', complete);
        document.addEventListener('addToCartFlyout:error', error);
      } catch (error) { event.detail.reject(error); }
    });

    document.addEventListener('product-form:cart:navigate', (event) => {
      if (event.target.closest('.ac-pdp') && !window.CART_REDIRECTION_ENABLED) event.preventDefault();
    });
  }



  // Robust gallery fallback: delegated listener works even if PDP init is interrupted
  // by another script or the section is dynamically re-rendered in the theme editor.
  if (!window.__acPdpGalleryDelegated) {
    window.__acPdpGalleryDelegated = true;
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-ac-pdp-thumb]');
      if (!button) return;

      const root = button.closest('[data-ac-pdp]');
      const main = root?.querySelector('[data-ac-pdp-main-image]');
      const nextSrc = button.dataset.imageSrc;
      if (!root || !main || !nextSrc) return;

      event.preventDefault();

      // Remove all responsive candidates first, then force the selected full image.
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.srcset = '';
      main.setAttribute('src', nextSrc);
      if (button.dataset.imageAlt) main.setAttribute('alt', button.dataset.imageAlt);

      root.querySelectorAll('[data-ac-pdp-thumb]').forEach((thumb) => {
        const active = thumb === button;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const button = event.target.closest?.('[data-ac-pdp-thumb]');
      if (!button) return;
      event.preventDefault();
      button.click();
    });
  }

  const init = () => {
    document.querySelectorAll('[data-ac-pdp]').forEach((root) => {
      initPdp(root);
      initPdpBreadcrumb(root);
    });
    bindCartFlyout();
  };
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
